<template>
  <v-row class="mb-4">
    <v-col cols="12" sm="4" class="pt-1">
      <FileUpload
        @attachment-file-add="addPassport"
        @attachment-file-remove="removePassport"
        :multi="true"
        :files="statePassportFiles"
        label="Паспорт"
        groupName="passport"
        name="passport"
      />
    </v-col>
  </v-row>
</template>

<script>
import FileUpload from "@/components/common/FileUploader.vue";
import { mapState, mapMutations } from "vuex";

export default {
  components: {
    FileUpload,
  },

  computed: {
    ...mapState({
      statePassportFiles: (state) => state.bid.passportFiles,
    }),
  },

  methods: {
    ...mapMutations("bid", [
      "setPassportDocs",
      "removePassportDocs",
    ]),

    addPassport(data) {
      this.setPassportDocs(data);
    },

    removePassport(id) {
      this.removePassportDocs(id);
    },
  },
};
</script>
